import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import {darkTheme,lightTheme} from "./theme.js"
import App from './App.js';
import { ThemeProvider } from '@emotion/react';
// import { AuthProvider } from './context/AuthContext.js';

const Index = () => {
  const [darkMode, setDarkMode] = useState(false);

  const toggleDarkMode = () => {
    setDarkMode((prevMode) => !prevMode);
  };


return(
  <BrowserRouter>
  {/* <AuthProvider> */}
  <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
    <App toggleDarkMode={toggleDarkMode} darkMode={darkMode} />
  </ThemeProvider>
  {/* </AuthProvider> */}
  </BrowserRouter>
);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Index />);

